import { WifiOff } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useOnlineStatus } from '@shared/offline/useOnlineStatus';

export const OfflineBanner = () => {
  const { t } = useTranslation();
  const isOnline = useOnlineStatus();

  if (isOnline) {
    return null;
  }

  return (
    <div className="sticky top-0 z-50 flex items-center justify-center gap-2 bg-signal-warn px-4 py-2 text-sm font-medium text-white">
      <WifiOff className="h-4 w-4" aria-hidden="true" />
      {t('offline.banner')}
    </div>
  );
};
